import PHQData from './PHQData';

export default PHQData;
